






import BaseLogo from "@/components/base/Logo/BaseLogo.vue";

export default {
  components: {BaseLogo},
  props: ["small"],
}
